"use client"
import {Button} from "@/components/ui/button";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import getStripe from "@/lib/utils/get-stripe";

export default function ButtonPayment({disabled,name, type, product, activity, cible,redirect_module, redirect_id,accompUserId, accompEmail, accompLastname, accompFirstname,trainingId,accompagnate, is_gift = false, offer_id, user_to,start_time, location_id}) {
    const axios = useAxiosAuth();



    const handleSubmit = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const stripe = await getStripe();

        if(!stripe){
            return;
        }

        try{
            let dataSend = {
                type : type,
                    product_id: product,
                    activity_id : activity,
                    cible_id : cible,
                    redirect_module : redirect_module,
                    redirect_id : redirect_id,
                    participant_userId: accompUserId,
                    training_id: trainingId,
                    offer_id: offer_id,
                    user_to : user_to,
                    start_time : start_time,
                    location_id : location_id,
            }

            if(accompagnate === 2){
                dataSend = {
                    ...dataSend,
                    participant_email : accompEmail,
                    participant_firstname: accompFirstname,
                    participant_lastname: accompLastname,
                    is_gift : is_gift,
                }
            }
            const response = await axios.post('payments/create-session', dataSend);

            const data = response.data.data;

            if(!data) throw new Error('Something went wrong');

            await stripe.redirectToCheckout({
                sessionId: data.session.id,
            })
        }catch(e){
            console.error(e);
        }
    }

    return (
        <Button onClick={handleSubmit} disabled={disabled}>
            {name}
        </Button>
    )
}